module.exports = {

  BASE_ROUTE: window.__POWERED_BY_QIANKUN__ ? '/web-envinfo' : ''

}